import { render, staticRenderFns } from "./element-info.vue?vue&type=template&id=0a34cd18&scoped=true&"
import script from "./element-info.vue?vue&type=script&lang=js&"
export * from "./element-info.vue?vue&type=script&lang=js&"
import style0 from "./element-info.vue?vue&type=style&index=0&id=0a34cd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34cd18",
  null
  
)

export default component.exports